import {
  HttpEvent, HttpHandler,

  HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { CertificationService } from '../certification/certification.service';
import { LoginService } from '../login/login.service';
import { DroitsService } from '../droits/droits.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(
    private _authService: AuthService,
    private _loginService: LoginService,
    private router: Router,
    private _certSrv: CertificationService,
    private _droitsSrv: DroitsService,
  ) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (req.url.includes(`${environment.basePath}`) && !req.url.includes(`${environment.basePath}/auth/login`)) {

      // Envoyer le cookie access-token automatiquement via withCredentials
      req = req.clone({ withCredentials: true });

      if (this._loginService.getCurrentUser()) {

        /**
         * Si l'appli est en mode certification
         * on ajoute la date de certification dans les header
         */
        if (this._certSrv.isCertificationMode) {
          const certDate = this._certSrv.getCertificationDateDuJour();
          if (certDate && certDate.isValid()) {
            req = req.clone({
              headers: req.headers.set('x-certification-date', certDate.format('YYYY-MM-DD HH:mm:ss'))
            });
          }
        }

        req = this._setBdgHeaders(req);
      }

      return next.handle(req).pipe(
        catchError((err) => {
          console.error('erreur', err);
          const isApi401 =
          err.url &&
          (err.url as string).includes(environment.basePath) &&
          !(err.url as string).includes(`${environment.basePath}/stellair`) &&
          err.status === 401;

          if (isApi401) {
            if (!this._loginService.logoutInProgress && !this._loginService.redirectingOn401) {
              this._loginService.redirectingOn401 = true;

              this._authService.logoutSession();
              this._loginService.clearLocalSession();

              this.router.navigateByUrl('/');

            }
          }
          throw err;
        })
      );
    } else {
      return next.handle(req).pipe(catchError((err) => {
        console.error('erreur', err);
        throw err;
      }));
    }
  }

  public _setBdgHeaders(request: HttpRequest<unknown>): HttpRequest<unknown> {
    let bdgRqt: HttpRequest<unknown>;
    const isBDG = this._droitsSrv.isBdg;
    if (isBDG) {
      bdgRqt = request.clone({
        headers: request.headers.set('x-bdg-actif', 'true')
      });
    } else {
      bdgRqt = request.clone({
        headers: request.headers.delete('x-bdg-actif')
      });
    }
    return bdgRqt;
  }
}
